(function () {
  function dismissMessage(message, duration) {
    if (!duration) return;

    window.setTimeout(function () {
      message.classList.add('is-dismissed');

      window.setTimeout(function () {
        message.remove();
      }, 400);
    }, duration);
  }

  function initSection(section) {
    if (section.dataset.messageDismissBound) return;
    section.dataset.messageDismissBound = 'true';

    var duration = parseInt(section.dataset.messageDuration, 10);
    if (!duration) return;

    section.querySelectorAll('[data-newsletter-form-message]').forEach(function (message) {
      dismissMessage(message, duration);
    });
  }

  function init() {
    document.querySelectorAll('[data-message-duration]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
